module.exports = __webpack_public_path__ + "img/sun-02.a9ea23c2.jpg";